<template>
  <main>
    <div class="fv">
      <div class="fv-inner">
        <div class="fv-main">
          <lp-hero :image-paths="imagePaths" />
        </div>
        <div class="fv-form">
          <lp-multi-step-form :form-top-src="imagePaths.formTop" />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import LpHero from './LpHero'
import LpMultiStepForm from './LpMultiStepForm'

export default {
  name: 'LpTopPage',
  components: { LpHero, LpMultiStepForm },
  props: {
    imagePaths: { type: Object, default: () => ({}) }
  }
}
</script>
